import { FC } from 'react';
import MainLayout from 'components/main-layout/MainLayout';
import { useQuery } from 'react-query';
import { buildClientEntity } from 'utils/helpers/client';
import { useActiveClientContext } from 'store/active-client';
import API from 'core/Api';
import { IDropdowns } from '../types';
import CreateForm from './CreateForm';

interface IProps {
  elementsEntityName: string;
  segmentIdKey: string;
}

const Create: FC<IProps> = ({ elementsEntityName, segmentIdKey }) => {
  const { client } = useActiveClientContext();
  const { data: dropdowns } = useQuery<IDropdowns, Error>(
    [buildClientEntity('client-elements-dropdowns', client)],
    (): Promise<IDropdowns> => {
      return API.get(`${elementsEntityName}/dropdown-options`).then(
        res =>
          res.data?.bg && {
            ...res.data.bg,
          }
      );
    }
  );
  const identifierOptions = [...(dropdowns?.paid_sub_types || []), ...(dropdowns?.work_trip_accommodation_types || [])];

  return (
    <MainLayout title="Добавяне на елемент">
      <CreateForm
        elementsEntityName={elementsEntityName}
        segmentIdKey={segmentIdKey}
        identifierOptions={identifierOptions}
      />
    </MainLayout>
  );
};

export default Create;
